import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";
import { getAnnuityFactor } from "web_myplann/Shared/Utils/getAnnuityFactor";

export const calcRentToZeroMonthly = (total: number, years: number): number => {
	if (total <= 0 || years <= 0) return 0;
	return Math.round(total / getAnnuityFactor(GOAL_REAL_YIELD / 12, years * 12));
};
